export const API_KEY = process.env.REACT_APP_API_KEY;

export default API_KEY;
